
















































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  private disabledStartDate: any = this.beginDate();
  private disabledEndDate: any = this.endDate();
  @Prop()
  private data: any;
  @Prop()
  private timeOptions: any;
  @Prop()
  private text: any;
  @Prop()
  private keyText: any; // 字段名字
  private get cData() {
    return this.data;
  }
  private beginDate() {
    const self = this;
    return {
      disabledDate(time: any) {
        if (self.cData["结束时间"]) {
          return (
            time.getTime() > new Date(self.cData["结束时间"]).getTime() ||
            time.getTime() > Date.now()
          );
        } else {
          return time.getTime() > Date.now();
        }
      },
    };
  }
  private endDate() {
    const self = this;
    return {
      disabledDate(time: any) {
        if (self.cData["开始时间"]) {
          return (
            new Date(self.cData["开始时间"]).getTime() > time.getTime() ||
            time.getTime() > Date.now()
          );
        } else {
          return time.getTime() > Date.now();
        }
      },
    };
  }
  private change(item: any) {
    this.cData["统计时间"] = item;
    this.cData["开始时间"] = "";
    this.cData["结束时间"] = "";
    this.$emit("change", this.cData);
  }
  private sure(item: any) {
    if (!this.cData["开始时间"] && !this.cData["结束时间"]) {
      this.$message.error("开始时间和结束时间至少要选择一个！");
      return;
    }
    this.$emit("change", this.cData);
  }
  private valueChange(e: any) {
    this.$emit("change", this.cData);
  }
}
